import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ActivatedRoute } from '@angular/router';

declare let gtag: any; // グローバル変数gtagを解決

@Component({
  selector: 'app-check-mail-complete',
  templateUrl: './check-mail-complete.component.html',
  styleUrls: ['./check-mail-complete.component.css']
})
export class CheckMailCompleteComponent implements OnInit {

  constructor(private activatedRoute: ActivatedRoute) { }

  readonly SCREEN_ID = 'O84';

  public message: string;
  public serviceName: string;

  ngOnInit() {
    this.message = 'メール認証が完了しました。メール送信完了画面に戻って処理を継続してください。';

    this.config();

    // サービス名取得
    this.serviceName = this.activatedRoute.snapshot.params['serviceName'];
    gtag('config', environment.analyticsId, {
      'page_path': this.serviceName + '_check-mail-complete',
      'page_title': 'check_mail_complete'
    });

    gtag('config', environment.analyticsIdGa4, {
      'page_title': 'check_mail_complete',
      'page_location': this.serviceName + '/check_mail_complete'
    });

  }

  /**
  * 共通初期設定
  */
  config() {
    const script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=' + environment.analyticsId;
    document.getElementById('gaid').appendChild(script);
  }
}
